export const formatSecondsToMinutes = seconds => {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  const paddedMins = mins.toString().padStart(2, '0')
  const paddedSecs = secs.toString().padStart(2, '0')
  return `${paddedMins}:${paddedSecs}`
}

export const formatMinutesToSeconds = timeString => {
  const [mins, secs] = timeString.split(':').map(Number)
  return mins * 60 + secs
}
